<template>
  <div class="table-container step4-table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-show="!isLoading">
        <div v-if="extras.communication_type === 2">
          <p>SMS</p>
          <sms
            :isTableInModal="true"
            :fields="fields.sms"
            repository="sms"
            filterName="filterSms"
            resource="sms"
            :ref="tableRef.sms"
            hasChecks
            isCheckExclusive
            noActions
          ></sms>
        </div>
        <div v-else-if="extras.communication_type === 0">
          <p>Email</p>
          <email
            :isTableInModal="true"
            :fields="fields.email"
            repository="email"
            filterName="filterEmail"
            resource="email"
            :ref="tableRef.email"
            hasChecks
            isCheckExclusive
            noActions
          ></email>
          <p>PDF</p>
          <pdf
            :isTableInModal="true"
            :fields="fields.pdf"
            repository="pdf"
            filterName="filterPdf"
            resource="pdf"
            :ref="tableRef.pdf"
            hasChecks
            isCheckExclusive
            noActions
          ></pdf>
          <div class="mt-3">
            <p class="mb-1">
              <strong>Mittente email:</strong>
              <b-spinner
                v-show="isSavingBrokerSender"
                small
                type="grow"
                variant="lisaweb"
                class="ml-2"
              ></b-spinner>
            </p>
            <b-form-radio-group
              v-model="broker_sender"
              stacked
              :disabled="isSavingBrokerSender"
              @change="onBrokerSenderChange"
            >
              <b-form-radio :value="0">
                Indirizzo agenzia ({{
                  agencyEmail ||
                  "Email non presente. E' necessario inserirla in Anagrafica di Agenzia"
                }})
              </b-form-radio>
              <b-form-radio :value="1"> Indirizzo del produttore </b-form-radio>
            </b-form-radio-group>
            <b-alert
              v-if="broker_sender === 1"
              show
              variant="warning"
              class="mt-2"
            >
              <strong>Attenzione!</strong><br />
              {{ noticeLabelPlural }} saranno inviati utilizzando come mittente
              l'indirizzo email del produttore, a condizione che nell'anagrafica
              del produttore sia censito un indirizzo email con lo stesso
              dominio dell'indirizzo dell'agenzia ({{
                agencyEmailDomain
              }}).<br />
              Qualora il produttore sia sprovvisto di indirizzo email, {{ noticeLabelSingular }}
              sarà spedito con l'indirizzo email dell'agenzia ({{
                agencyEmail || "..."
              }}).<br />
              Qualora nell'anagrafica del produttore sia censito un indirizzo
              email con dominio diverso da {{ agencyEmailDomain }}, {{ noticeLabelSingular }}
              sarà spedito utilizzando l'indirizzo dell'agenzia, ma
              eventuali risposte del cliente verranno recapitate direttamente al
              produttore.
            </b-alert>
          </div>
        </div>
        <div v-else-if="extras.communication_type === 3">
          <p>PDF</p>
          <pdf
            :isTableInModal="true"
            :fields="fields.pdf"
            repository="pdf"
            filterName="filterPdf"
            resource="pdf"
            :ref="tableRef.pdf"
            hasChecks
            isCheckExclusive
            noActions
          ></pdf>
        </div>
        <b-row
          class="justify-content-end m-0"
          style="z-index: 99; position: fixed; right: 40px; bottom: 10px"
          v-if="isStepReady"
        >
          <b-button
            @click="onSend()"
            type="button"
            variant="lisaweb"
            size="sm"
            :disabled="!canSend || isSavingBrokerSender"
          >
            Invia selezionati
          </b-button>
        </b-row>
        <send-procedure-modal @send="send"></send-procedure-modal>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import Sms from "@/components/tables/Sms.vue";
import Email from "@/components/tables/Email.vue";
import Pdf from "@/components/tables/Pdf.vue";
import SendProcedureModal from "@/components/modals/sendProcedureModal.vue";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
import FormMixin from "@/mixins/FormMixin";
import { mapActions } from "vuex";
import { RepositoryFactory } from "@/repositories/lisacomunica/RepositoryFactory";
import { RepositoryFactory as MainRepositoryFactory } from "@/repositories/RepositoryFactory";

export default {
  mixins: [FormMixin, ConfirmModalMixin],
  data() {
    return {
      buttonWidth: null,
      isLoading: false, // altrimenti le tableRef non sono già disponibili quando chiama la prima volta computed canSend
      isStepReady: false,
      broker_sender: 0,
      isSavingBrokerSender: false,
      agencyEmail: "",
      repository: "communication_procedure",
      resource: "communication_procedures",
      form: {
        communication_procedure: {},
      },
      tableRef: {
        sms: "smsTableRef",
        email: "emailTableRef",
        pdf: "pdfTableRef",
      },
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
      fields: {
        sms: [
          {
            key: "check",
            label: "",
            sortable: false,
            thClass: "check",
            class: "check",
          },
          {
            key: "title",
            label: "Titolo",
          },
          {
            key: "type",
            label: "Tipo",
            formatter: (value) => this.getType(value),
          },
          {
            key: "text_content",
            label: "Testo",
          },
        ],
        email: [
          {
            key: "check",
            label: "",
            sortable: false,
            thClass: "check",
            class: "check",
          },
          {
            key: "title",
            label: "Titolo",
          },
          {
            key: "type",
            label: "Tipo",
            formatter: (value) => this.getType(value),
          },
          {
            key: "subject",
            label: "Oggetto",
          },
        ],
        pdf: [
          {
            key: "check",
            label: "",
            sortable: false,
            thClass: "check",
            class: "check",
          },
          {
            key: "title",
            label: "Titolo",
          },
          {
            key: "type",
            label: "Tipo",
            formatter: (value) => this.getType(value),
          },
          {
            key: "header",
            label: "Header",
          },
          {
            key: "body",
            label: "Body",
          },
          {
            key: "ads",
            label: "Ads",
          },
          {
            key: "footer",
            label: "Footer",
          },
        ],
      },
      filterName: {
        sms: "smsFilter",
        email: "emailFilter",
        pdf: "pdfFilter",
      },
    };
  },
  props: {
    resourceId: Number,
    extras: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    Sms,
    Email,
    Pdf,
    SendProcedureModal,
  },
  methods: {
    validate() {
      // change `true` to things checked on model, beyond scope of question
      // this.$emit("on-validate", this.$data, true);
      // this.$emit("on-validate", true, this.index);
      this.$emit("on-validate", true, this.index);
      return true;
    },
    getType(value) {
      return this.types.find((type) => type.value === value).text;
    },
    templateTypeQuery() {
      return `type=${this.extras.category === 1 ? "SOLL" : "AVV_SCAD"}`;
    },
    loadIndex(communication_type) {
      this.isLoading = true;
      this.isStepReady = false;
      if (communication_type === 0) {
        // email
        let Repo = RepositoryFactory.get("email");
        // this.$refs[this.tableRef.email]
        // .fetch()
        Repo.index(this.templateTypeQuery())
          .then((response) => {
            console.log("email", response.data.content);
            this.$refs[this.tableRef.email].items = response.data.content;
            // this.removeFilterByName(name);
            // this.isLoading = false;
            Repo = RepositoryFactory.get("pdf");
            // this.$refs[this.tableRef.pdf]
            //   .fetch()
            Repo.index(this.templateTypeQuery())
              .then((response) => {
                console.log("pdf", response.data.content);
                this.$refs[this.tableRef.pdf].items = response.data.content;
                // this.removeFilterByName(name);
                // this.isLoading = false;
                // this.isStepReady = true;
              })
              .catch((error) => {
                let errMsg = this.$getErrorMessage(error);
                this.$showSnackbar({
                  preset: "error",
                  text: errMsg,
                });
              })
              .finally(() => {
                this.isLoading = false;
                this.resize();
                this.isStepReady = true;
              });
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: errMsg,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.resize();
            this.isStepReady = true;
          });
      } else if (communication_type === 2) {
        const Repo = RepositoryFactory.get("sms");
        // sms
        // this.$refs[this.tableRef.sms]
        //   .fetch()
        Repo.index(this.templateTypeQuery())
          .then((response) => {
            console.log("sms", response.data.content);
            this.$refs[this.tableRef.sms].items = response.data.content;
            // this.removeFilterByName(name);
            // this.isLoading = false;
            // this.isStepReady = true;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: errMsg,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.resize();
            this.isStepReady = true;
          });
      } else if (communication_type === 3) {
        const Repo = RepositoryFactory.get("pdf");
        // sms
        // this.$refs[this.tableRef.sms]
        //   .fetch()
        Repo.index(this.templateTypeQuery())
          .then((response) => {
            this.$refs[this.tableRef.pdf].items = response.data.content;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: errMsg,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.resize();
            this.isStepReady = true;
          });
      }
    },
    onBrokerSenderChange(value) {
      const rollback = value === 1 ? 0 : 1;
      this.isSavingBrokerSender = true;
      this.fetchEditForm(this.repository, parseInt(this.resourceId))
        .then(() => {
          this.form[this.repository].broker_sender = value;
          this.update(this.repository, this.resourceId)
            .then(() => {
              this.$showSnackbar({
                preset: "success",
                text: "Impostazione salvata",
              });
            })
            .catch((error) => {
              this.broker_sender = rollback;
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({ preset: "error", text: errMsg });
            })
            .finally(() => {
              this.isSavingBrokerSender = false;
            });
        })
        .catch((error) => {
          this.broker_sender = rollback;
          this.isSavingBrokerSender = false;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        });
    },
    fetchAgencyEmail() {
      const Repo = MainRepositoryFactory.get("agency_setup");
      Repo.show(1, "relations/byAddressBook")
        .then((response) => {
          const addressBooks = response.data.data.address_books;
          if (addressBooks && addressBooks.length) {
            this.agencyEmail = addressBooks[0].attributables.MAIL || "";
          }
        })
        .catch(() => {
          // non bloccante, lascia agencyEmail vuota
        });
    },
    onSend() {
      if (this.isSavingBrokerSender) return;
      // Solo email (0) e sms (2) si possono programmare: la stampa PDF non passa
      // dalle code di LisaComunica e resta con la conferma di sempre.
      if ([0, 2].includes(this.extras.communication_type)) {
        this.$bvModal.show("sendProcedureModal");
        return;
      }
      this.showConfirm({
        yesCallback: this.send,
        noCallback: null,
        title: "Conferma operazione",
        message:
          this.extras.category === 1
            ? "Confermi l'invio dei Solleciti?"
            : "Confermi l'invio degli Avvisi di scadenza?",
        yesLabel: "Invia",
        noLabel: "Annulla",
        // yesVariant:
        // noVariant:
        // headerBgVariant:
      });
    },
    /* scheduledAt null = invia subito */
    send(scheduledAt = null) {
      // #842
      // 0. fetch edit per il payload della update
      // 1. put verso la procedura + aggiorna status (next) + snack "Procedura inviata"
      // 2. start procedure_id in lisacomunica
      // 3. redirect a index procedure
      // 4. rollback status_procedure se lisacomunica va in errore
      // 0. fetch edit
      this.fetchEditForm(this.repository, parseInt(this.resourceId))
        .then(() => {
          this.finalize(scheduledAt);
          /* .then(() => {
              // // next: finisci (lo faccio nel payload di finalize);
              // @validate nel Wizard rimane (ma inutilizzato)
              // this.$emit("validate", "Step4", 3);
              // 3. redirect to Procedures index
              this.emptyQueue();
              this.notifyQueue({
                level: 0,
                path: "",
                text: "Comunicazioni",
              });
              this.$router.push({
                name: "communication_procedures.index",
              });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: errMsg,
              });
            }) */
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: errMsg,
          });
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },
    finalize(scheduledAt = null) {
      // 1. put
      switch (this.extras.communication_type) {
        case 0: // email
          this.form[this.repository].template_id =
            this.$refs[this.tableRef.email].selectedRows[0];
          this.form[this.repository].pdf_template_id =
            this.$refs[this.tableRef.pdf].selectedRows[0];
          break;
        case 2: // sms
          this.form[this.repository].template_id =
            this.$refs[this.tableRef.sms].selectedRows[0];
          break;
        case 3: // stampa pdf
          this.form[this.repository].pdf_template_id =
            this.$refs[this.tableRef.pdf].selectedRows[0];
          break;
        default:
          break;
      }
      // #842: (aggiornare direttamente anche status_procedure: 5)
      // Con una schedulazione futura lo stato è 6 (Schedulato): sarà il
      // callback di LisaComunica a portarlo a 5 quando l'invio parte davvero.
      this.form[this.repository].status_procedure = scheduledAt ? 6 : 5;
      this.form[this.repository].scheduled_at = scheduledAt;
      this.isLoading = true;
      return this.update(this.repository, this.resourceId)
        .then(() => {
          // 2. start procedure_id (resourceId)
          let Repo;
          switch (this.extras.communication_type) {
            case 0: // email
              Repo = RepositoryFactory.get("email");
              break;
            case 2: // sms
              Repo = RepositoryFactory.get("sms");
              break;
            case 3: // stampa pdf
              Repo = RepositoryFactory.get("pdf");
              break;
            default:
              break;
          }
          // const Repo =
          //   this.extras.communication_type === 2
          //     ? RepositoryFactory.get("sms")
          //     : RepositoryFactory.get("email");
          let payload = {
            procedure_id: this.resourceId,
            scheduled_at: scheduledAt,
          };
          Repo.start(payload)
            .then(() => {
              this.$showSnackbar({
                preset: "success",
                text: scheduledAt
                  ? `Azione Completata: Procedura Programmata`
                  : `Azione Completata: Procedura Inviata`,
              });
              this.isLoading = false;
              // 3. redirect to Procedures index
              this.emptyQueue();
              this.notifyQueue({
                level: 0,
                path: "",
                text: "Comunicazioni",
              });
              this.$router.push({
                name: "communication_procedures.index",
              });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: errMsg,
              });
              // 4. rollback status_procedure
              this.form[this.repository].status_procedure = 4;
              return this.update(this.repository, this.resourceId)
                .then(() => {
                  this.$showSnackbar({
                    preset: "success",
                    text: `Azione Completata: Rollback Procedura`,
                  });
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: errMsg,
                  });
                })
                .finally(() => {
                  this.isLoading = false;
                });
              // this.isLoading = false; // togliere se abilito il rollback
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },
    resize() {
      console.log("resize Wizard step4", this.$refs.wizard?.$el.clientWidth);
      // this.buttonWidth = null;
      // this.buttonWidth = `width: calc(${this.$refs.wizard?.$el.clientWidth}px + 2rem);`;
      this.buttonWidth = `width: ${
        document.querySelector(".dashboard").clientWidth
      }px;`;
    },
    ...mapActions("queue", ["notifyQueue", "emptyQueue"]),
  },
  created() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    let ct = this.extras.communication_type;
    this.broker_sender = this.extras.broker_sender ? 1 : 0;
    this.fetchAgencyEmail();
    this.loadIndex(ct);
  },
  computed: {
    getWidth() {
      return this.buttonWidth;
    },
    agencyEmailDomain() {
      if (!this.agencyEmail) return "";
      const atIndex = this.agencyEmail.indexOf("@");
      return atIndex !== -1 ? this.agencyEmail.slice(atIndex) : "";
    },
    noticeLabelPlural() {
      return this.extras.category === 1 ? "I solleciti" : "Gli avvisi di scadenza";
    },
    noticeLabelSingular() {
      return this.extras.category === 1 ? "il sollecito" : "l'avviso di scadenza";
    },
    canSend() {
      // #842: pdf non è obbligatorio
      return this.extras.communication_type === 0
        ? this.$refs[this.tableRef.email].items.some((e) => e.check)
        : this.extras.communication_type === 2
        ? this.$refs[this.tableRef.sms].items.some((e) => e.check)
        : this.extras.communication_type === 3
        ? this.$refs[this.tableRef.pdf].items.some((e) => e.check)
        : false;
    },
  },
};
</script>

<style>
.step4-table-container div:has(> table) {
  margin-left: 0;
}
.step4-table-container > div:first-of-type {
  padding-right: 0;
}
</style>
